
import { Vue } from "vue-class-component";
import moment from "moment";
import { set, get, keys, Store } from "idb-keyval";
import { Guid } from "guid-typescript";
import { Match } from "../models/Models";
import { SpondService } from '../services/SpondService';
import axios from 'axios';
import { inject } from 'vue';
import router from '../router';

export default class SpondLogin extends Vue {
  private username = '';
  private password = ''
  private loginError = false;
  private spondService: SpondService;

  $refs: {
    usernameInput: HTMLFormElement;
  };

  created() {
    this.spondService = inject('SpondService', new SpondService());
    
    setTimeout(() => {
      this.$refs.usernameInput.focus();
    });
  }

  goToSpondMatches() {  
    router.push({ name: "SpondGroups" });
  }

  loginToSpond() {
    this.spondService.login(this.username, this.password)
      .then(async response => {
        this.loginError = false;
        this.goToSpondMatches();
      })
      .catch(err => {
        this.loginError = true;
      });
  }
}
